import IconAnalyzeGradient, {
	IconAnalyzeGradientProps as _IconAnalyzeGradientProps,
} from './IconAnalyzeGradient';

export { IconAnalyzeGradient };
export type IconAnalyzeGradientProps = _IconAnalyzeGradientProps;
